import React from 'react';
import {
  FormGroup,
  Label,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
  FormFeedback,
} from 'reactstrap';
import Required from '../Required';
import { withTranslation } from 'react-i18next';

const CustomDropdown = ({
  data = [],
  value,
  valueKey,
  nameKey,
  subtitleKey,
  invalid,
  error,
  t,
  ...props
}) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };
  return (
    <FormGroup>
      <Label>
        {t(props.label)} {props.required && <Required />}
      </Label>
      <ButtonDropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        className={props.className}
      >
        <DropdownToggle
          caret
          color={invalid ? 'danger' : 'secondary'}
          className={props.dropdownToggleClassName}
          style={props.dropdownToggleStyle}
        >
          {(props.translated ? t(value) : value) || t(props.label)}
        </DropdownToggle>
        <DropdownMenu>
          {data.map((d, index) => (
            <React.Fragment
              key={props.keyField ? d[props.keyField] : d[valueKey]}
            >
              <DropdownItem
                value={`${d[valueKey]}`}
                style={{ boxSizing: 'border-box' }}
                onClick={() => {
                  if (props.onChange) {
                    props.onChange({
                      value: d[valueKey],
                      text: d[nameKey],
                    });
                  }
                }}
              >
                {props.translated ? (
                  <p>{t(d[nameKey])}</p>
                ) : (
                  <p>{d[nameKey]}</p>
                )}
                {subtitleKey && (
                  <p
                    style={{
                      fontSize: '0.75rem',
                      fontStyle: 'italic',
                    }}
                  >
                    {d[subtitleKey]}
                  </p>
                )}
              </DropdownItem>
              {index + 1 !== data.length && <DropdownItem divider />}
            </React.Fragment>
          ))}
        </DropdownMenu>
      </ButtonDropdown>
      {invalid && <FormFeedback>{t(error)}</FormFeedback>}
    </FormGroup>
  );
};

export default withTranslation('app')(CustomDropdown);
